/**
 * floatingButtonsControl.ts
 * フローティングボタンのドラッグ操作メソッド
 * App.vue から切り出し
 */

type VM = any
type PointerDragEvent = MouseEvent | TouchEvent

/** タッチ/マウスイベントからクライアント座標を取得 */
function getClientXY(e: PointerDragEvent): { clientX: number; clientY: number } {
  if ('touches' in e && e.touches.length > 0) {
    return { clientX: e.touches[0].clientX, clientY: e.touches[0].clientY }
  }
  return { clientX: (e as MouseEvent).clientX, clientY: (e as MouseEvent).clientY }
}

export function startFloatingButtonsDrag(vm: VM, e: PointerDragEvent) {
  const floatingEl = document.getElementById('floating-buttons')
  if (!floatingEl) return

  vm.floatingButtonsDragging = true
  const rect = floatingEl.getBoundingClientRect()

  const { clientX, clientY } = getClientXY(e)

  vm.floatingButtonsDragOffset = {
    x: clientX - rect.left,
    y: clientY - rect.top
  }

  // グローバルイベントリスナーを追加
  document.addEventListener('mousemove', vm.onFloatingButtonsDrag)
  document.addEventListener('mouseup', vm.endFloatingButtonsDrag)
  document.addEventListener('touchmove', vm.onFloatingButtonsDrag, { passive: false })
  document.addEventListener('touchend', vm.endFloatingButtonsDrag)

  floatingEl.style.cursor = 'grabbing'
}
export function onFloatingButtonsDrag(vm: VM, e: PointerDragEvent) {
  if (!vm.floatingButtonsDragging) return
  e.preventDefault()

  const floatingEl = document.getElementById('floating-buttons')
  if (!floatingEl) return

  const { clientX, clientY } = getClientXY(e)

  const map01Element = document.querySelector('#map01')
  if (!map01Element) return
  const mapRect = map01Element.getBoundingClientRect()
  const panelW = floatingEl.offsetWidth
  const panelH = floatingEl.offsetHeight
  const M = 10

  // 新しい位置を計算
  let left = clientX - vm.floatingButtonsDragOffset.x
  let top = clientY - vm.floatingButtonsDragOffset.y

  // 境界チェック
  if (left < M) left = M
  if (left + panelW > mapRect.width - M) left = mapRect.width - panelW - M
  if (top < M) top = M
  if (top + panelH > mapRect.height - M) top = mapRect.height - panelH - M

  floatingEl.style.left = left + 'px'
  floatingEl.style.top = top + 'px'

  // ユーザー位置を保存
  vm.floatingButtonsUserPos = { left, top }
}
export function endFloatingButtonsDrag(vm: VM) {
  vm.floatingButtonsDragging = false

  document.removeEventListener('mousemove', vm.onFloatingButtonsDrag)
  document.removeEventListener('mouseup', vm.endFloatingButtonsDrag)
  document.removeEventListener('touchmove', vm.onFloatingButtonsDrag)
  document.removeEventListener('touchend', vm.endFloatingButtonsDrag)

  const floatingEl = document.getElementById('floating-buttons')
  if (floatingEl) {
    floatingEl.style.cursor = ''
  }
}
export function resetFloatingButtonsPos(vm: VM) {
  // ユーザー位置をリセット（自動追従に戻す）
  vm.floatingButtonsUserPos = null
}